import { InteractableBaseModel } from '../models/classes/base/InteractableBaseModel';
import { PublicatableEntityService } from './publicatable-entity.service';

export class InteractableEntityService<T extends InteractableBaseModel, TCreate, TUpdate> extends PublicatableEntityService<T, TCreate, TUpdate> {

}
